import React, {Component} from 'react';
import {connect} from 'react-redux';
import queryString from 'query-string';

class PayletterClose extends Component {
  componentDidMount() {
    if (this.props.match.params.result === 'success') {
      this._close('완료 되었습니다.');
    } else if (this.props.match.params.result === 'cancel') {
      this._close('취소 되었습니다.');
    } else if (this.props.match.params.result === 'fail') {
      let params = queryString.parse(this.props.location.search);
      this._close('작업이 실패 되었습니다. ' + params.reason);
    } else {
      this._close();
    }
  }

  _close(message) {
    if (message) {
      alert(message);
    }
    window.close();
  }

  render() {
    return <div id="paymentClose"></div>;
  }
}

export default connect()(PayletterClose);
